import Vue from 'vue'
import Vuex from 'vuex'
import http from '@/http/axios';
import api from '@/http/api';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: '',
    isLogin: false,
    config: '',
    configCallBack: '',
    userInfoCallBack: '',
  },
  mutations: {
    setData(state,data){
      state[data['key']] = data['val'];
    }
  },
  actions: {
    getConfig( {state} ){
      return new Promise(resolve=>{
        if(state.config){
          return resolve(state.config)
        }else{
          state.configCallBack = (config)=>{
            resolve(config)
          }
        }
      })
      
    },
    getUserInfo( { state} ){
      return new Promise(resolve=>{
        if(state.userInfo){
          return resolve(state.userInfo)
        }else{
          state.userInfoCallBack = (userInfo)=>{
            resolve(userInfo)
          }
        }
      })
    },
    async config( {state, commit} ){
      try{
        let data = await http.get(api.config);
        state.configCallBack&&state.configCallBack(data.data);
        commit('setData',{
          key:'config',
          val: data.data
        })
        return Promise.resolve(data.data)
      }catch(error){
        return Promise.reject(error)
      }
    },
    async getUser( { state, commit}, { uid } ){
      http.get(api.getUserInfo, { params: { uid } }).then(
        (data) => {
          state.userInfoCallBack&&state.userInfoCallBack(data.data);
          commit('setData',{
            key:'userInfo',
            val: data.data
          })
          return Promise.resolve(data.data)
        },
        (e) => {
          throw new Error(e);
        }
      );
    }
  },
  modules: {
  }
})
